import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { useHistory, useLocation } from 'react-router-dom';
import { showError } from '../../../common/A1Alert/A1Alert';
import ShowPassword from '../../../common/showPassword/ShowPassword';


const ResetPassword = ({ passwordResetted, submitting, resetPassword, userId, resetToken }) => {
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordConf, setNewPasswordConf] = useState('');
    const history = useHistory();
    const location = useLocation();
    const pathname = location.pathname;

    useEffect(() => {
        if (passwordResetted === true) {
            history.replace(pathname);
        }
    }, [history, pathname, passwordResetted]);

    const onSubmit = (e) => {
        e.preventDefault();

        if (newPassword.length < 6) {
            showError('A senha não deve conter menos de 6 caracteres');

            return;
        }

        if (newPassword !== newPasswordConf) {
            showError('A senha e a confirmação não conferem!');

            return;
        }

        resetPassword(userId, newPassword, resetToken);
    };

    return (
        <section className="sectionResetPassword">
            <header>
                <h2>Redefinição de senha</h2>
            </header>
            <div className="containerResetPassword">
                {
                    passwordResetted ?
                        <div>
                            <p className="tw-mb-0">
                                Sua senha foi alterada com sucesso!
                                <br />
                                Clique abaixo para realizar o login:
                            </p>
                        </div>
                        :
                        <form onSubmit={onSubmit}>
                            {
                                !passwordResetted && (
                                    <div>
                                        <div className="passwordResetPassword">
                                            <ShowPassword
                                                type="password"
                                                id="newPassword"
                                                label="Nova senha"
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                            />
                                        </div>
                                        <div className="passwordResetPassword">
                                            <ShowPassword
                                                type="password"
                                                id="newPasswordConf"
                                                label="Confirmar nova senha"
                                                value={newPasswordConf}
                                                onChange={(e) => setNewPasswordConf(e.target.value)}
                                            />
                                        </div>
                                        <p className="tw-text-xs tw-text-[#777C86]">Sua senha deve ter no mínimo 6 caracteres. Recomendamos usar letra maiúscula, letra minúscula, número, símbolo e no mínimo 8 caracteres.</p>
                                        <div>
                                            <button type="submit" className="cta" disabled={!!submitting}>
                                                {submitting === 'resetPassword' ? 'Aguarde...' : 'Enviar'}
                                            </button>
                                        </div>
                                    </div>
                                )
                            }
                        </form>
                }
            </div>
        </section>
    );
};

ResetPassword.propTypes = exact({
    userId: PropTypes.number.isRequired,
    resetToken: PropTypes.string.isRequired,
    passwordResetted: PropTypes.bool.isRequired,
    resetPassword: PropTypes.func.isRequired,
    submitting: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]).isRequired,
});

export default ResetPassword;
